//@ts-nocheck
/*
@ts-ignore
@ts-nocheck
 */
import axios from "axios";
import _ from "lodash";
import { t } from "i18next";

import AlertsService from "services/alerts-service";

import { mergeStorage, omitStorage } from "hooks/useStorage";

const ClubsApi = {
    getMyClubs: async () => {
        try {
            const { data: response } = (await axios.get("/clubs/my")) as any;
            mergeStorage(`clubs`, _.keyBy(response, `id`));
            return response;
        } catch (error) {
            throw AlertsService.showError(t('bujbvk1ee54'));
        }
    },
    createClub: async (details: any) => {
        try {
            const { data: response } = (await axios.post("/clubs", {})) as any;
            await ClubsApi.getMyClubs();
            return response;
        } catch (error) {
            throw AlertsService.showError(t('ucn98jsft2'));
        }
    },
    updateClub: async (data: Object) => {
        try {
            let dd = {...data};
            delete dd.hideFromAll;
            const { data: response } = (await axios.put(`/clubs`, dd)) as any;
            await ClubsApi.getAllClubs();
            AlertsService.showSuccess(`Студтурклуб успешно обновлен`);
            return response;
        } catch (error) {
            throw AlertsService.showError(t('oc4wpjt0rro'));
        }
    },
    deleteClub: async (id: string) => {
        try {
            await axios.delete(`/clubs/${id}`);
            omitStorage(`clubs.${id}`);
            await ClubsApi.getMyClubs();
            AlertsService.showSuccess(`Студтурклуб успешно удален`);
        } catch (error) {
            throw AlertsService.showError(t('ztdstxy6d6'));
        }
    },
    getAllClubs: async () => {
        try {
            const { data: response } = (await axios.get("/clubs/all")) as any;
            mergeStorage(`clubs`, _.keyBy(response, `id`));
            return response;
        } catch (error) {
            throw AlertsService.showError(t('vku33272v1'));
        }
    },
    getClubInfo: async (id: string) => {
        try {
            const { data: response } = (await axios.get(`/clubs/${id}`)) as any;
            mergeStorage(`clubs.${id}`, response);
            return response;
        } catch (error) {
            throw AlertsService.showError(t('bs6mwijfc6t'));
        }
    },

    getAllClubsData: async () => {
        try {
            const { data: clubs } = (await axios.get("/clubs/all")) as any;
            mergeStorage(`clubs`, _.keyBy(clubs, `id`));
            return;
        } catch (error) {
            throw AlertsService.showError(t("kxz5dhn1ckg"));
        }
    },

};

export default ClubsApi;
